import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { range } from 'lodash';
import BlockPlaceholder from 'components/consumer/BlockPlaceholder';
import TextPlaceholder from 'components/consumer/TextPlaceholder';
const PLACEHOLDER_ITEMS_DESKTOP = range(1, 9);
const CollectionsGridDesktopPlaceholders = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>{PLACEHOLDER_ITEMS_DESKTOP.map(_temp)}</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CollectionsGridDesktopPlaceholders;
function _temp(item) {
  return <div className={classNames("group/collection-grid-item cursor-pointer", "focus:outline-0", "focus-visible:[outline-style:auto] focus-visible:outline-2 focus-visible:outline-brand focus-visible:outline-offset-0 focus-visible:p-[5px]")} key={item}><div className={classNames("relative [transition:transform_.25s_ease-in-out]", "before:[content:\"\"] before:block before:pt-[100%]", "[&_img]:top-0 [&_img]:left-0 [&_img]:h-full [&_img]:w-full [&_img]:absolute [&_img]:rounded", "group-hover/collection-grid-item:md:!scale-105 group-hover/collection-grid-item:min-[1600px]:!transform-[scale(1.03)]")}><BlockPlaceholder className="!top-0 !left-0 !h-full !w-full !absolute !rounded" /></div><div className="text-xl font-bold text-gray mt-[1.375rem] mb-[.4rem]"><TextPlaceholder className="!top-0 !left-0 !absolute !rounded !w-3/4 !h-[30px]" /></div><div className="text-sm mb-10"><TextPlaceholder className="!top-0 !left-0 !h-[40px] !w-full !absolute !rounded" /></div></div>;
}